import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";


import { NotFoundPageRoutingModule } from "./not-found-routing.module";

import { NotFoundPage } from "./not-found.page";
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [
		CommonModule,
		FormsModule,
        NotFoundPageRoutingModule,
        TranslateModule
	],
    declarations: [NotFoundPage],
    exports: [NotFoundPage]
})
export class NotFoundPageModule {}
